import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.contrastText,
        height: '100vh',
        textAlign: 'center',
        boxShadow: "rgb(0 94 235) 0px -20px 250px 20px inset, rgb(6 9 51) 1px -20px 300px 20px inset, rgb(0 59 255 / 40%) 0px -20px 20px 20px inset, rgb(52 94 235) 0px -20px 9px 0px, rgb(0 0 0 / 9%) 0px 4px 2px, inset rgb(0 0 0 / 9%) 1px -20px 20px 20px, rgb(0 0 0 / 9%) 0px 16px 8px, rgb(63 15 179 / 9%) 0px -20px 20px 20px"
     },
     gridImage: {
        paddingTop: 150
     },
     image: {
        width: 350,
        float: 'inherit',
        [theme.breakpoints.down('xs')]: {
           width: 300,
        },
     },
     gridVersion: {
      marginTop : 20
     },
}))
